import { useState, useEffect } from "react";

import DropBox, { UploadedFile } from "../../../components/shared/DropBox";
import AttorneySelect from "../../../components/shared/AttorneySelect";

import { Endpoints } from "../../../helpers/Endpoints";
import useBank from "../../../helpers/hooks/useBank";

export default function DropInFiling(): JSX.Element {
    const [_selectedFirm, setSelectedFirm] = useState({} as string);
    const [selectedAttorney, setSelectedAttorney] = useState("");

    const newBank = useBank<UploadedFile>();
    const existingBank = useBank<UploadedFile>();

    useEffect(() => {
        console.log("newBank", newBank);
    }, [newBank]);

    useEffect(() => {
        console.log("existingBank", existingBank);
    }, [existingBank]);

    return (
        <div className="card">
            <div className="card-body">
                <div className="row">
                    <AttorneySelect
                        onFirmSelected={(id, _name) => {
                            setSelectedFirm(id);
                        }}
                        onAttorneySelected={(id, _name) => {
                            setSelectedAttorney(id);
                        }}
                    />
                </div>
                <div
                    className="row"
                    {...(selectedAttorney === ""
                        ? {
                              style: {
                                  pointerEvents: "none",
                                  opacity: 0.3,
                              },
                          }
                        : { style: {} })}
                >
                    <DropBox
                        className="col-sm-6"
                        label="Drop Existing Files Here."
                        url={Endpoints.ThirdParty.Existing}
                        selectedAttorney={selectedAttorney}
                        bank={existingBank}
                    />
                    <DropBox
                        className="col-sm-6"
                        label="Drop New Files Here."
                        url={Endpoints.ThirdParty.New}
                        selectedAttorney={selectedAttorney}
                        bank={newBank}
                    />
                </div>
            </div>
        </div>
    );
}
